import React from 'react';
import { Badge as ReactstrapBadge } from 'reactstrap';
import styled, { CSSProperties, Interpolation } from 'styled-components';

type Props = {
  status?: string;
  statusMap?: StatusMap;
};

type StatusMap = {
  [key: PropertyKey]: {
    label?: string;
    color?: string;
    bgColor?: string;
    isRounded?: boolean;
    borderColor?: string;
  };
};

const defaultStatusMap: StatusMap = {
  active: {
    label: '有効',
    color: 'white',
    bgColor: '#008000',
  },
  suspended: {
    label: '凍結中',
    color: 'black',
    bgColor: '#ddd',
  },
  'pre-closed': {
    label: '退会準備中',
    color: 'black',
    bgColor: '#ddd',
  },
  closed: {
    label: '退会済',
    color: 'white',
    bgColor: 'black',
  },
};

export const Badge = styled(ReactstrapBadge)<Props & { styles?: Interpolation<CSSProperties> }>`
  padding: 0.35em 0.6em;
  font-size: small;
  color: ${({ status = '', statusMap = defaultStatusMap }) =>
    statusMap?.[status]?.color ?? 'white'};
  background-color: ${({ status = '', statusMap = defaultStatusMap }) =>
    statusMap?.[status]?.bgColor ?? '#008000'};
  border-radius: ${({ status = '', statusMap = defaultStatusMap }) =>
    statusMap?.[status]?.isRounded === false ? '0' : '5px'};
  border: 1px solid
    ${({ status = '', statusMap = defaultStatusMap }) =>
      statusMap?.[status]?.borderColor ?? 'transparent'};
  ${(props) => props.styles}
`;

export const createBadge =
  (statusMap?: StatusMap, { styles }: { styles?: Interpolation<CSSProperties> } = {}) =>
  ({ status }: { status: string }) => {
    return (
      <Badge statusMap={statusMap ?? defaultStatusMap} status={status} styles={styles}>
        {(status && statusMap ? statusMap?.[status]?.label : defaultStatusMap?.[status]?.label) ??
          status}
      </Badge>
    );
  };

export default Badge;
